import { postForm } from '@/shared/api/client';

export interface RepairReferral {
  bid_id?: number;
  car?: { mark?: string; model?: string } | null;
  services?: Array<{ id: number | string; name?: string }>;
  service_station?: {
    name?: string;
    address?: string;
    phone?: string;
    photo_url?: string;
    coordinates?: { lat?: number | string; long?: number | string } | null;
  } | null;
  discount?: { applied_discount_percent?: number | string; discount_name?: string } | null;
  qr?: { image_url?: string } | null;
}

/** `bid/direction/` returns the referral either at the top level or under `data` (legacy handled both). */
export async function fetchRepairReferral(bidId: number) {
  const res = await postForm<RepairReferral & { data?: RepairReferral }>('/bid/direction/', { bid_id: bidId });
  return res.data ?? res;
}
